export class GlobalProductNames {
  static readonly Expand = "Expand";
  static readonly Praemium = "Praemium";
  static readonly CFSEdge = "CFS Edge";
  static readonly Essential = "Essential";
  static readonly North = "North";
}

export class GlobalSubProductNames {
  static readonly ExpandEssential = "Essential";
  static readonly PraemiumSpectrum = "Spectrum";
}

export const GlobalProductsToHideSubProductName = [
  GlobalProductNames.CFSEdge,
  GlobalProductNames.North,
];

export const SubProductsIgnoreMultiMenuAccountLogic = [
  {
    productName: GlobalProductNames.Expand,
    subProductName: GlobalSubProductNames.ExpandEssential,
  },
];
